import {
  NEW_NGUOI_DUNG_SUCCESS,
  NEW_NGUOI_DUNG_FAIL,
  DELETE_NGUOI_DUNG_SUCCESS,
  DELETE_NGUOI_DUNG_FAIL,
  CHANGE_LOADING_STATE
} from 'src/constants/ActionTypes';
import Helper from 'src/helpers';
import { messages } from 'src/constants/messages';

const initialState = {
  refresh: false,
  setEmpty: false,
  data: [],
  hasError: false,
  status: 200
};
const nguoiDungReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_NGUOI_DUNG_SUCCESS: {
      const responseStatus = action.status;
      if (responseStatus === 200 || responseStatus === 201) {
        Helper.alertSuccessMessage(messages.THEM_THANH_CONG);
        // eslint-disable-next-line no-param-reassign
        state.data = action.data;
        return {
          ...state, error: '', message: messages.THEM_THANH_CONG, loading: false
        };
      }
      return { ...state };
    }
    case NEW_NGUOI_DUNG_FAIL:
      return {
        ...state, error: action.payload, message: messages.LUU_THAT_BAI, loading: false
      };
    case DELETE_NGUOI_DUNG_SUCCESS:
      Helper.alertSuccessMessage(messages.XOA_THANH_CONG);
      return {
        ...state, error: '', message: '', loading: true
      };
    case DELETE_NGUOI_DUNG_FAIL:
      return {
        ...state, error: action.payload, message: '', loading: false
      };
    case CHANGE_LOADING_STATE:
      return {
        ...state, error: '', message: '', loading: action.payload.loading
      };
    default:
      return state;
  }
};

export default {
  nguoiDungReducer
};
